import { render, staticRenderFns } from "./CommonTabContent.vue?vue&type=template&id=483a8901&scoped=true&"
import script from "./CommonTabContent.vue?vue&type=script&lang=ts&"
export * from "./CommonTabContent.vue?vue&type=script&lang=ts&"
import style0 from "./CommonTabContent.vue?vue&type=style&index=0&id=483a8901&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483a8901",
  null
  
)

export default component.exports